import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { MapPin, Calendar, Users, Sparkles } from 'lucide-react';
export const EventDetailsSection = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: sectionRef,
    offset: ['start end', 'end start']
  });
  const opacity = useTransform(scrollYProgress, [0, 0.2, 0.8, 1], [0, 1, 1, 0]);
  return <motion.section id="details" ref={sectionRef} className="py-20 md:py-28 bg-black relative overflow-hidden" style={{
    opacity
  }} data-id="element-864">
      <div className="absolute inset-0 bg-gradient-to-b from-amber-950/10 to-black/60 z-0" data-id="element-865"></div>
      <div className="container mx-auto px-4 relative z-10" data-id="element-866">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-24" data-id="element-867">
          <p className="text-amber-400/60 tracking-[0.3em] text-xs uppercase mb-6" data-id="element-868">
            Essential Information
          </p>
          <h2 className="font-serif text-5xl md:text-7xl text-white mb-8" data-id="element-869">
            EVENT
            <br data-id="element-870" />
            <span className="text-amber-400" data-id="element-871">DETAILS</span>
          </h2>
          <div className="w-24 h-px bg-amber-400/30 mx-auto" data-id="element-872"></div>
        </motion.div>
        <div className="max-w-6xl mx-auto" data-id="element-873">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-16" data-id="element-874">
            {/* Venue Card */}
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} data-id="element-875">
              <div className="relative" data-id="element-876">
                <div className="aspect-video relative overflow-hidden mb-8 rounded-lg" data-id="element-877">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kppHXez1XGBnRYW5bwUDVX/illumiarium.png" alt="Illuminarium Venue" className="w-full h-full object-contain bg-black" data-id="element-878" />
                </div>
                <div className="space-y-8" data-id="element-879">
                  <div className="flex items-start" data-id="element-880">
                    <MapPin className="w-6 h-6 text-amber-400 mr-4 flex-shrink-0 mt-1" data-id="element-881" />
                    <div data-id="element-882">
                      <h4 className="font-serif text-2xl text-amber-400 mb-3" data-id="element-883">
                        Venue
                      </h4>
                      <p className="text-white/80 font-light leading-relaxed" data-id="element-884">
                        Illuminarium Toronto
                        <br data-id="element-885" />
                        123 Experience Drive
                        <br data-id="element-886" />
                        Toronto, ON M5V 2K4
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start" data-id="element-887">
                    <Calendar className="w-6 h-6 text-amber-400 mr-4 flex-shrink-0 mt-1" data-id="element-888" />
                    <div data-id="element-889">
                      <h4 className="font-serif text-2xl text-amber-400 mb-3" data-id="element-890">
                        Dates
                      </h4>
                      <p className="text-white/80 font-light leading-relaxed" data-id="element-891">
                        Spring 2026
                        <br data-id="element-892" />
                        Doors open at 6:00 PM
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
            {/* Details Card */}
            <motion.div initial={{
            opacity: 0,
            x: 30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.8
          }} className="flex flex-col justify-between space-y-8" data-id="element-893">
              <div className="space-y-8" data-id="element-894">
                <div className="flex items-start" data-id="element-895">
                  <Users className="w-6 h-6 text-amber-400 mr-4 flex-shrink-0 mt-1" data-id="element-896" />
                  <div data-id="element-897">
                    <h4 className="font-serif text-2xl text-amber-400 mb-3" data-id="element-898">
                      Capacity
                    </h4>
                    <p className="text-white/80 font-light leading-relaxed" data-id="element-899">
                      Limited & exclusive seating
                      <br data-id="element-900" />
                      Only 120 guests per evening
                    </p>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-901">
                  <Sparkles className="w-6 h-6 text-amber-400 mr-4 flex-shrink-0 mt-1" data-id="element-902" />
                  <div data-id="element-903">
                    <h4 className="font-serif text-2xl text-amber-400 mb-3" data-id="element-904">
                      Format
                    </h4>
                    <p className="text-white/80 font-light leading-relaxed" data-id="element-905">
                      Sikh Foundation Centennial Gala experience
                      <br data-id="element-906" />
                      Immersive dining and cultural showcase
                    </p>
                  </div>
                </div>
              </div>
              <div className="border border-amber-400/30 p-8 bg-black/40" data-id="element-907">
                <h3 className="font-serif text-3xl text-amber-400 mb-4" data-id="element-908">
                  Spring 2026
                </h3>
                <p className="text-white/70 font-light mb-4 leading-relaxed" data-id="element-909">
                  The exclusive experience takes place Spring 2026. All ticket
                  holders receive admission to this premiere experience.
                </p>
                <div className="w-full h-px bg-white/10 my-6" data-id="element-910"></div>
                <h4 className="text-xl text-amber-400 font-light mb-3" data-id="element-911">
                  Monthly Experiences
                </h4>
                <p className="text-white/70 font-light mb-6 leading-relaxed" data-id="element-912">
                  Your ticket also grants access to one monthly experience
                  between May and December 2026. Choose your preferred date when
                  finalizing your reservation.
                </p>
                <div className="flex justify-between items-center pt-4 border-t border-white/10" data-id="element-913">
                  <span className="text-amber-400 font-light tracking-wider" data-id="element-914">
                    Spring 2026
                  </span>
                  <span className="text-white/60 text-sm tracking-wider uppercase" data-id="element-915">
                    Premiere Event
                  </span>
                </div>
                <div className="flex justify-between items-center pt-3" data-id="element-916">
                  <span className="text-amber-400 font-light tracking-wider" data-id="element-917">
                    May - Dec 2026
                  </span>
                  <span className="text-white/60 text-sm tracking-wider uppercase" data-id="element-918">
                    Monthly Access
                  </span>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
        {/* Bottom Quote */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="text-center mt-24" data-id="element-919">
          <p className="text-xl text-white/70 italic font-light max-w-3xl mx-auto" data-id="element-920">
            "Mark your calendars for two unforgettable evenings of history,
            culture, and culinary excellence."
          </p>
        </motion.div>
      </div>
    </motion.section>;
};